// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75157":"2d9efb32","78612":"29feb691","85900":"29feb691","87373":"fc868170"}[chunkId] + ".chunk.css";
};